var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header-wrapper ui-p-4 ui-pl-8 ui-flex ui-flex-row ui-w-full"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }